import { render, staticRenderFns } from "./bidui-list.vue?vue&type=template&id=bfe43b6e&"
import script from "./bidui-list.vue?vue&type=script&lang=ts&"
export * from "./bidui-list.vue?vue&type=script&lang=ts&"
import style0 from "./bidui-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports